import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const PurposeOfRequest = () => {
  return(
    <SettingsMetaData propertyName={"PurposeOfRequest"} viewPropertyName={"Purpose Of Request"} />
  )
};

export default PurposeOfRequest;
